//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const Styles = makeStyles((theme) => ({
  root: {
    margin: "20px 0px",
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  country: {
    flexGrow: 1,
  },
  editBtn: {
    backgroundColor: "#2F7CBD",
    color: "#fff",
    fontSize: 15,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#2F7CBD!important",
    },
    // "@media (max-width: 595px)": {
    //   float: "right",
    // },
  },
  historyBtn: {
    backgroundColor: "#2F7CBD",
    color: "#fff",
    fontSize: 15,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#2F7CBD!important",
    },
    float: "right",
  },
  gridDiv: {
    padding: 10,
  },
  firstDiv: {
    backgroundColor: "#E4E4E4",
  },
  secondDiv: {
    color: "#707070",
    fontSize: 22,
    fontWeight: "bold",
    padding: 5,
    "@media (max-width: 768px)": {
      fontSize: 20,
    },
  },
  iconBtn: {
    padding: 0,
  },
  menuIcon: {
    color: "#707070",
  },
  fieldName: {
    color: "#707070",
    fontSize: "1.125rem",
  },
  values: {
    color: "#000000",
    fontSize: "1.25rem",
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
}));

export const editStyles = makeStyles((theme) => ({
  parentGrid: {
    marginTop: 50,
    marginBottom: 50,
    "@media (max-width: 600px)": {
      marginTop: 0,
      marginBottom: 0,
      padding: 20,
    },
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  texts: {
    paddingTop: 15,
    fontSize: 21,
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)":
      {
        paddingTop: 35,
      },
  },
  input: {
    width: "90%",
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  btnGrid: {
    "@media (max-width: 600px)": {
      textAlign: "center",
    },
  },
  btn: {
    backgroundColor: "#2F7CBD",
    color: "#fff",
    fontSize: 15,
    textTransform: "capitalize",
    borderRadius: 10,
    width: 100,
    "&:hover": {
      backgroundColor: "#2F7CBD",
    },
  },
  pointsToDollar: {
    fontSize: 22,
  },
  backBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    width: 100,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  dateInput: {
    width: "90%",
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  dateInputTexts:{
    // paddingTop: 10,
    fontSize: 21,
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)":
      {
        paddingTop: 35,
      },
  }
}));
